(function () {
  const STORAGE_PREFIX = 'dfe-product-upsells:';

  function storageKey(productId) {
    return `${STORAGE_PREFIX}${productId}`;
  }

  function readStoredIds(productId) {
    if (!productId) return [];
    try {
      const raw = sessionStorage.getItem(storageKey(productId));
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map(Number).filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function writeStoredIds(productId, ids) {
    if (!productId) return;
    try {
      sessionStorage.setItem(storageKey(productId), JSON.stringify(ids));
    } catch (e) {
      // Ignore private mode / quota errors
    }
  }

  function setCardSelected(card, selected) {
    card.classList.toggle('is-selected', selected);
    card.setAttribute('aria-pressed', selected ? 'true' : 'false');
  }

  function getGroupSelectedIds(group) {
    const ids = [];
    group.querySelectorAll('[data-product-upsell].is-selected').forEach((card) => {
      const id = Number(card.dataset.variantId);
      if (id && !ids.includes(id)) ids.push(id);
    });
    return ids;
  }

  function persistGroup(group) {
    writeStoredIds(group.dataset.productId, getGroupSelectedIds(group));
  }

  async function fetchCartVariantIds() {
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return new Set();
      const cart = await response.json();
      const ids = new Set();
      (cart.items || []).forEach((item) => {
        if (item.variant_id) ids.add(Number(item.variant_id));
      });
      return ids;
    } catch (e) {
      return new Set();
    }
  }

  async function syncGroupSelection(group) {
    const productId = group.dataset.productId;
    let selectedIds = [];

    try {
      const hasStored = sessionStorage.getItem(storageKey(productId)) !== null;
      if (hasStored) {
        // Respect customer's last selection (including unselect)
        selectedIds = readStoredIds(productId);
      } else {
        // First visit this session: pre-select upsells already in cart
        const cartIds = await fetchCartVariantIds();
        group.querySelectorAll('[data-product-upsell]').forEach((card) => {
          const variantId = Number(card.dataset.variantId);
          if (variantId && cartIds.has(variantId)) selectedIds.push(variantId);
        });
        writeStoredIds(productId, selectedIds);
      }
    } catch (e) {
      selectedIds = readStoredIds(productId);
    }

    group.querySelectorAll('[data-product-upsell]').forEach((card) => {
      const variantId = Number(card.dataset.variantId);
      setCardSelected(card, selectedIds.includes(variantId));
    });
  }

  function initUpsells(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-product-upsells]').forEach((group) => {
      if (group.dataset.upsellsBound === 'true') return;
      group.dataset.upsellsBound = 'true';

      group.querySelectorAll('[data-product-upsell]').forEach((card) => {
        card.addEventListener('click', () => {
          const selected = !card.classList.contains('is-selected');
          setCardSelected(card, selected);
          persistGroup(group);
        });
      });

      syncGroupSelection(group);
    });
  }

  function getSelectedUpsellVariantIds(formEl) {
    return getSelectedUpsells(formEl).map((item) => item.variantId);
  }

  function getSelectedUpsells(formEl) {
    // Include matching-band section cards (below product info), not only buy-buttons.
    const cards = document.querySelectorAll('[data-product-upsell].is-selected');
    const items = [];
    const seen = new Set();
    cards.forEach((card) => {
      const variantId = Number(card.dataset.variantId);
      if (!variantId || seen.has(variantId)) return;
      seen.add(variantId);
      items.push({
        variantId,
        productId: Number(card.dataset.productId) || null,
        isMatchingBand: card.hasAttribute('data-matching-band'),
        discountPercent: Number(card.dataset.upsellDiscountPercent) || 0,
      });
    });
    return items;
  }

  window.ProductUpsells = {
    init: initUpsells,
    getSelectedVariantIds: getSelectedUpsellVariantIds,
    getSelectedUpsells,
    fetchCartVariantIds,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initUpsells());
  } else {
    initUpsells();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initUpsells(event.target);
  });
})();
